// src/store/index.ts
import { createStore } from 'vuex';

import counter from '@/store/modules/Counter';
import auth from '@/store/modules/Auth';
import report from '@/store/modules/Report';
import account from '@/store/modules/Account';
import profile from '@/store/modules/Profile';
import balance from '@/store/modules/Balance';
import general from '@/store/modules/General';
import game from '@/store/modules/Game';
import statement from '@/store/modules/Statement';
import suggest from '@/store/modules/Suggest';
import dashboard from '@/store/modules/Dashboard';
import announcement from '@/store/modules/Announcement';
import agentbanner from '@/store/modules/AgentBanner';
import apikey from '@/store/modules/ApiKey';
import useronline from '@/store/modules/Useronline';
import bankaccount from '@/store/modules/BankAccount';
import social from '@/store/modules/Social';
import promotion from '@/store/modules/Promotion';
import document from '@/store/modules/Document';
import currency from '@/store/modules/Currency';
import resetlog from '@/store/modules/ResetPasswordLog';
import commissionlog from '@/store/modules/UpdateCommissionLog';
import secretpassword from '@/store/modules/SecretPassword';
import point from '@/store/modules/Point';
import activity from '@/store/modules/Activity';
import marketing from '@/store/modules/Marketing';
import admin from '@/store/modules/Admin';
import legendofdolly from '@/store/modules/LegendOfDolly';
import user from '@/store/modules/User';
import setting from '@/store/modules/Setting';
import whitelabel from '@/store/modules/WhiteLabel';
import coin from '@/store/modules/Coin';
import invitefriend from '@/store/modules/InviteFriend';
import mechanic from '@/store/modules/Mechanic';
import domainPool from '@/store/modules/DomainPool';
import campaign from '@/store/modules/Campaign';
import trackingLogs from '@/store/modules/TrackingLogs';
import invoice from '@/store/modules/Invoice';
import faq from '@/store/modules/Faq';

const store = createStore({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    counter,
    auth,
    report,
    account,
    profile,
    balance,
    general,
    game,
    statement,
    suggest,
    dashboard,
    announcement,
    agentbanner,
    apikey,
    useronline,
    bankaccount,
    social,
    promotion,
    document,
    currency,
    resetlog,
    secretpassword,
    point,
    activity,
    marketing,
    admin,
    commissionlog,
    legendofdolly,
    user,
    setting,
    whitelabel,
    coin,
    invitefriend,
    mechanic,
    domainPool,
    campaign,
    trackingLogs,
    invoice,
    faq
  }
});

export default store;
export type RootState = typeof store.state;
